import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7b2f4a08")
const _hoisted_1 = { class: "interface" }
const _hoisted_2 = ["onload", "src"]
const _hoisted_3 = {
  key: 0,
  class: "clickPrompt"
}
const _hoisted_4 = {
  key: 2,
  class: "functions"
}
const _hoisted_5 = {
  key: 3,
  class: "empty"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Click to select image (optional)", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "background"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_ImageSelector = _resolveComponent("ImageSelector")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({lazyWrapper:true,tutorial: _ctx.tutorial,upload: _ctx.upload,empty:(!_ctx.preview&&!_ctx.image&&!_ctx.src), uploading:_ctx.uploadVisible}),
    ref: "wrapper",
    style: _normalizeStyle(_ctx.position)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({lightbox:true,hidden:!_ctx.fullScreen}),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_IconButton, {
            icon: "new_tab",
            onClick: _withModifiers(_ctx.newTab, ["stop"]),
            clear: true,
            type: "svg",
            hex: "#FFFFFF"
          }, null, 8, ["onClick"]),
          _createVNode(_component_IconButton, {
            icon: "cross",
            clear: true,
            type: "svg",
            hex: "#FFFFFF"
          })
        ]),
        _createElementVNode("img", {
          ref: "img",
          onload: _ctx.rendered,
          src: _ctx.image,
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, _hoisted_2)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({_img:true, loaded: _ctx.loaded, lazyImage:true, empty:(!_ctx.preview&&!_ctx.image&&!_ctx.src)}),
      style: _normalizeStyle(`background-image: url(${_ctx.preview || _ctx.image}); background-size: cover`),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args)))
    }, [
      (!_ctx.patching)
        ? (_openBlock(), _createBlock(_component_Ripple, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.upload)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.uploadVisible && (_ctx.image || _ctx.preview))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Click to change "))
              : _createCommentVNode("", true),
            (_ctx.uploadVisible)
              ? (_openBlock(), _createBlock(_component_ImageSelector, {
                  key: 1,
                  onPreview: _ctx.showPreview,
                  onClose: _ctx.closeUpload,
                  onNewImageURL: _ctx.changeImageURL
                }, null, 8, ["onPreview", "onClose", "onNewImageURL"]))
              : _createCommentVNode("", true)
          ], 64))
        : (!_ctx.hideExpand)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_IconButton, {
                icon: "new_tab",
                type: "svg",
                onClick: _withModifiers(_ctx.newTab, ["stop"]),
                clear: true,
                hex: "#ffffff"
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
      (_ctx.upload && !_ctx.src && !_ctx.image && !_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
    ], 6),
    (!_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_MovingIcon, {
            class: "loadingIndicator",
            name: "loader_dots",
            autoplay: true,
            loop: true
          })
        ]))
      : _createCommentVNode("", true)
  ], 6))
}